import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { usePopoverHandlers } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { ABTestCookie, ABTestCookieValue } from '@as-react/common-types';
import { uniqueId } from '@as-react/common-utils';
import { useState, useEffect, useImperativeHandle } from 'react';
import { useDispatch } from 'react-redux';
import { useABTest } from '../../../hooks/useABTest';
import { analyticsActions } from '../../../redux/analytics/actions/AnalyticsActions.creators';
import { getABEnabledFeatureToggleValue } from '../../../util/FilterUtil';
import { useProductMedia } from '../product-media/useProductMedia';
import { ProductPreviewLightBox } from './product-preview-light-box/ProductPreviewLightBox';
import { ProductPreviewMainSlider } from './product-preview-main-slider/ProductPreviewMainSlider';
import { ProductPreviewThumbSlider } from './product-preview-thumb-slider/ProductPreviewThumbSlider';
const INITIAL_SLIDE_INDEX = 0;
const id = uniqueId('', '', 4);
const carouselOffsetMap = new Map([
    [ABTestCookieValue.A, 1],
    [ABTestCookieValue.B, 1.2],
    [ABTestCookieValue.C, 1.3],
]);
export var SlideInViewFrom;
(function (SlideInViewFrom) {
    SlideInViewFrom["CAROUSEL"] = "C";
    SlideInViewFrom["LIGHTBOX"] = "L";
})(SlideInViewFrom || (SlideInViewFrom = {}));
const ProductPreview = ({ selectedColorId, productId, showImageTouchZoomHint, disableLightbox = false, onImageTouchZoom, innerRef, }) => {
    const { mediaCollection, alt } = useProductMedia();
    const { feature_toggles: { enable_pdp_andes, enable_pdp_carousel }, pageInfo: { isPDPPage }, } = useAemConfig();
    const { hasBCookie: pdpAndesCookie } = useABTest(ABTestCookie.PDP_ANDES);
    const { getCookie: carouselCookie } = useABTest(ABTestCookie.PDP_CAROUSEL);
    const isAndesEnabled = getABEnabledFeatureToggleValue(enable_pdp_andes, Boolean(pdpAndesCookie));
    const [activeSlideIndex, setActiveSlideIndex] = useState(INITIAL_SLIDE_INDEX);
    const isCarouselABCookieEnabled = getABEnabledFeatureToggleValue(enable_pdp_carousel, mediaCollection.length > 1 && isPDPPage && isAndesEnabled);
    const slidesPerView = carouselCookie ? carouselOffsetMap.get(carouselCookie) : 1;
    const [showABTestVariant, setShowABTestVariant] = useState(isCarouselABCookieEnabled);
    const popoverHandlers = usePopoverHandlers();
    const dispatch = useDispatch();
    const handleUpdateSlideInView = (index, from) => {
        if (isNaN(index)) {
            return;
        }
        const uniqueImageId = `${id}_${productId}_${selectedColorId}_${index}${from}`;
        dispatch(analyticsActions.productDetailCarouselImageViewed(uniqueImageId));
    };
    const onActiveSlideIndexChange = (newActiveSlideIndex) => {
        setActiveSlideIndex(newActiveSlideIndex);
    };
    useImperativeHandle(innerRef, () => ({
        openLightboxAtIndex: (index, event) => {
            if (disableLightbox) {
                return;
            }
            setActiveSlideIndex(index);
            popoverHandlers.handlePopoverOpen(event);
        },
    }), [disableLightbox, popoverHandlers]);
    useEffect(() => {
        setActiveSlideIndex(INITIAL_SLIDE_INDEX);
        setShowABTestVariant(isCarouselABCookieEnabled);
    }, [selectedColorId, mediaCollection.length]);
    if (!mediaCollection)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(ProductPreviewThumbSlider, { activeSlideIndex: activeSlideIndex, alt: alt, mediaCollection: mediaCollection, onActiveSlideIndexChange: onActiveSlideIndexChange }), showABTestVariant ? (_jsx(ProductPreviewMainSlider, { selectedColorId: selectedColorId, activeSlideIndex: activeSlideIndex, onActiveSlideIndexChange: onActiveSlideIndexChange, onUpdateSlideInView: isAndesEnabled ? handleUpdateSlideInView : undefined, showImageTouchZoomHint: showImageTouchZoomHint, onImageTouchZoom: onImageTouchZoom, popoverHandlers: disableLightbox ? undefined : popoverHandlers, slidesPerView: slidesPerView }, "ab-test-variant")) : (_jsx(ProductPreviewMainSlider, { selectedColorId: selectedColorId, activeSlideIndex: activeSlideIndex, onActiveSlideIndexChange: onActiveSlideIndexChange, showImageTouchZoomHint: showImageTouchZoomHint, onImageTouchZoom: onImageTouchZoom, popoverHandlers: disableLightbox ? undefined : popoverHandlers, slidesPerView: 1 }, "default")), !disableLightbox && (_jsx(ProductPreviewLightBox, { activeSlideIndex: activeSlideIndex, alt: alt, mediaCollection: mediaCollection, onActiveSlideIndexChange: onActiveSlideIndexChange, onUpdateSlideInView: showABTestVariant ? handleUpdateSlideInView : undefined, popoverHandlers: popoverHandlers }))] }));
};
export default ProductPreview;
